import KyMethod from "./KyMethod"

export default class TestimonyRepositories extends KyMethod {
  protected async getRawTestimonyList() {
    return this._getStrapiProtectedData("/testimonies?populate=*")
  }
  protected async getRawTestimonyDetail(id: string) {
    return this._getStrapiProtectedData(`/testimonies/${id}?populate=*`)
  }
}
